<template>
  <div>
    <app-nav :full-name="userFullName" />

    <div class="columns">
      <div class="column"/>
      <div class="column is-three-quarters">

        <!-- factory form, should be populated with data if existing factory -->
        <form @submit.prevent="saveFactory">
          <b-field label="Factory Name">
            <b-input
              v-model="factoryName"
              name="factoryName"
              placeholder="Awesome Business Company" />
          </b-field>

          <b-field
            label="Factory Code"
            message="Factory Code cannot be changed once created.">
            <b-input
              v-model="factoryCode"
              :disabled="factoryCodeDisabled"
              name="factoryCode"
              placeholder="ABC" />
          </b-field>

          <b-field label="Factory Contact Name">
            <b-input
              v-model="factoryContactName"
              name="factoryContactName"
              placeholder="John Wang" />
          </b-field>

          <b-field label="Factory Contact Email">
            <b-input
              v-model="factoryContactEmail"
              name="factoryContactEmail"
              placeholder="john.wang@company.com" />
          </b-field>

          <b-field label="Factory Contact Phone">
            <b-input
              v-model="factoryContactPhone"
              name="factoryContactPhone"
              placeholder="123-456-7890" />
          </b-field>

          <b-field label="Factory Address">
            <b-input
              v-model="factoryAddress"
              type="textarea"
              name="factoryAddress"
              placeholder="123 Main Street" />
          </b-field>

          <div class="field is-grouped">
            <div class="control">
              <button
                class="button is-link">Save</button>
            </div>
            <div class="control">
              <router-link
                class="button is-danger is-outlined"
                to="/factories">Cancel</router-link>
            </div>
          </div>

        </form>

      </div>
      <div class="column"/>
    </div>

    <b-loading
      :is-full-page="true"
      :active.sync="isLoading"
      :can-cancel="true" />
  </div>
</template>

<script>
import AppNav from './AppNav'
import { checkLogin, getUser } from '../utils/auth'
import { getFactory, saveFactory } from '../utils/api'

export default {
  name: 'factory',
  components: {
    AppNav
  },
  data() {
    return {
      factory: {},
      factoryCodeDisabled: false,
      // navbar
      userFullName: '',
      // loading
      isLoading: false,
      // input values
      factoryName: '',
      factoryCode: '',
      factoryContactName: '',
      factoryContactEmail: '',
      factoryContactPhone: '',
      factoryAddress: ''
    }
  },
  mounted() {
    let self = this
    checkLogin().then(function(loggedIn) {
      if (loggedIn) {
        self.getFactory()
        self.userFullName = JSON.parse(getUser()).fullName
      } else {
        self.$router.push('/login')
      }
    })
  },
  methods: {
    getFactory() {
      let self = this
      if (this.$route.params.factoryCode !== undefined) {
        self.isLoading = true
        let factoryCodeParam = this.$route.params.factoryCode
        getFactory(factoryCodeParam).then((factory) => {
          self.factory = factory
          // populate input values
          self.factoryCode = self.factory.factoryCode
          self.factoryName = self.factory.factoryName
          self.factoryContactName = self.factory.factoryContactName
          self.factoryContactEmail = self.factory.factoryContactEmail
          self.factoryContactPhone = self.factory.factoryContactPhone
          self.factoryAddress = self.factory.factoryAddress
          // disable code input
          self.factoryCodeDisabled = true
        }).catch(function() {
          self.$toast.open({
            message: 'Failed to get factory information.',
            duration: 3000,
            position: 'is-top',
            type: 'is-danger'
          })
        }).finally(function() {
          self.isLoading = false
        })
      }
    },
    saveFactory() {
      let factory = {
        factoryCode: this.factoryCode,
        factoryName: this.factoryName,
        factoryContactName: this.factoryContactName,
        factoryContactEmail: this.factoryContactEmail,
        factoryContactPhone: this.factoryContactPhone,
        factoryAddress: this.factoryAddress
      }
      let self = this
      let existingFactory = (self.factory !== undefined && self.factory.factoryCode !== undefined && self.factory.factoryCode !== '')
      saveFactory(factory, existingFactory)
        .then(function(response) {
          self.$toast.open({
            message: 'Factory was saved successfully.',
            duration: 5000,
            position: 'is-top',
            type: 'is-success'
          })
          let code = response.data
          self.$router.push(`/factories/${code}`)
        })
        .catch(function(error) {
          console.log(error)
          self.$toast.open({
            message: 'Failed to save factory in database.',
            duration: 5000,
            position: 'is-top',
            type: 'is-danger'
          })
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.field .label .label-description {
  font-size: 0.75rem;
  font-style: italic;
  font-weight: normal;
}
.field .label .required-field{
  color: red;
  font-weight: bold;
}
section {
  padding: 0.5rem 0rem;
}
.followup {
  margin-left: 2rem;
}
hr {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.content {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Factory.vue